import { LISTE_TERME_PAIEMENT } from '@/configuration/baux/contrat/contratConf';
import i18n from '@/i18n';

export default function verificationTermePaiement(termePaiementBaux) {
  [...new Set(termePaiementBaux)].forEach((termePaiement) => {
    if (termePaiement === undefined) return;
    const isInEnum = LISTE_TERME_PAIEMENT.find((terme) => {
      return i18n.t(terme.libelle).toLowerCase() === termePaiement.toLowerCase();
    });
    const errors = [];
    if (!isInEnum) {
      errors.push({
        message: 'importDonne.dataNotExist',
        parametres: { data: termePaiement },
      });
    }
    if (errors.length > 0) throw errors;
  });
}
